<div class="p-6">
  <h2 class="text-2xl font-semibold text-gray-900 mb-6">Create Paddock</h2>

  <form [formGroup]="createPaddockForm" class="space-y-4">
    <div class="space-y-4">
      <!-- Name Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Name</label>
                <input 
          formControlName="name" 
          type="text" 
          placeholder="Enter paddock name"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-400 placeholder:italic"
        >
      </div>

      <!-- Total Area Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Total Area (ha)</label>
        <input
          type="number"
          readonly
          [value]="paddock.area"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-500 cursor-not-allowed"
        >
      </div>

      <!-- Landuse Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Landuse</label>
        <select
          formControlName="landuseType"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option [value]="null" disabled>Choose Landuse</option>
          <option *ngFor="let landuseType of dropdownService.landuseTypes | async" [ngValue]="landuseType">
            {{ landuseType.name }}
          </option>
        </select>
      </div>

      <!-- Enterprise Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Enterprise</label>
        <select
          formControlName="cropType"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option [value]="null" disabled>Choose Enterprise</option>

          @for (enterprise of filteredEnterpriseTypes(); track $index) {
          <option  [ngValue]="enterprise">
             {{ enterprise.name }}
          </option>
          }


        </select>
      </div>

      <!-- Notes Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Notes</label>
                <textarea 
          formControlName="notes" 
          rows="4"
          placeholder="Enter any additional notes..."
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical placeholder:text-gray-400 placeholder:italic"
        ></textarea>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
    <button
      type="button"
      [mat-dialog-close]="false"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      Cancel
    </button>
    <button
      (click)="submit()"
      [disabled]="!createPaddockForm.valid"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Save
    </button>
  </div>
</div>
